import { Col, Row } from "react-bootstrap";
import SessionAttendence from "./SessionAttendence";
import { memo, useMemo } from "react";
import LineGraph from "components/Graph/LineGraph";
import { GOAL_TRACK_PARAMETERS, GOAL_TRACK_PARAMETERS_COLORS } from "config/constants";

const TreatmentSummaryGoalsPreview = memo(function TreatmentSummaryGoalsPreview({ innerRefs, data, notes }) {
  const { attendance, chart_data, period, selected_goals } = data?.answer?.other_details || {};
  
  return (
    <>
      <div className="py-3">
        <h6 className="m-0 fw-sbold themeBlue pb-1">
          Attendance
        </h6>
        <div className="border rounded-4">
          <SessionAttendence
            data={attendance}
          />
        </div>
      </div>
        {selected_goals?.length > 0 ?
      <div className="py-3">
        <div
          className="p-3 px-lg-5"
          style={{ background: "#F6F6F6" }}
        >
          <h6 className="m-0 fw-sbold themeBlue pb-1">
            Select Data to Graph
          </h6>
          <div className="table-responsive">
            <table className="table border rounded">
              <thead>
                <tr>
                  {selected_goals?.map((_, index) => {
                    return (
                      <th key={index} className="px-3 py-3">
                        <h6
                          className="m-0 d-flex align-items-start themeBlue fw-bold"
                          style={{ fontSize: "14px" }}
                        >
                          <span
                            className="icn me-1"
                            style={{ color: " rgb(61, 160, 170)" }}
                          >
                            ■{" "}
                          </span>{" "}
                          Goal
                        </h6>
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {selected_goals?.map((goalId, index) => {
                    let goal = chart_data[goalId]?.goalData;
                    return (
                      <td key={index} className="px-3 py-3">
                        <div className="d-flex align-items-center gap-10">
                          <input
                            type="checkbox"
                            style={{ height: 20, width: 20, opacity: 0 }}
                            className="form-check"
                            checked={true}
                            disabled={true}
                          />
                          <p className="m-0">{goal?.assesmentGoalDetail?.title}</p>
                        </div>
                      </td>
                    )
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      : ''}
      {selected_goals?.length > 0 && (
        selected_goals.map((goalId, index) => {
          let goal = chart_data[goalId]?.goalData;
          let goalReview = 
            notes?.answer?.other_details?.goal_notes &&
            notes?.answer?.other_details?.goal_notes[goalId];

          return (
            <div key={index} className="py-3">
              <div className="">
                <GoalTrackingChartPreview
                  index={index}
                  goalId={goalId}
                  goal={goal}
                  chartData={chart_data}
                  innerRef={(el) => (innerRefs.current[index] = el)}
                />
                <div className="py-2">
                  <div className="">
                    <h6 className="m-0 fw-sbold themeBlue pb-1">
                      Goal Review
                    </h6>
                    {goalReview?.other_details?.radio_tag && (
                      <div className=" d-flex align-items-center gap-10 mb-2">
                        <div
                          className="rounded-pill px-3 py-1  fw-sbold themeBlue"
                          style={{ background: "#BEF9FF" }}
                        >
                          {goalReview?.other_details?.radio_tag}
                        </div>
                      </div>
                    )}
                    <p className="m-0 themeBlue">
                      {goalReview?.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )
        })
      )}
    </>
  )
})

const GoalTrackingChartPreview = memo(function GoalTrackingChartPreview({ innerRef, index, goalId, goal, chartData }) {
  const { dates, series } = useMemo(() => {
    try {
      if(!goalId || !chartData || !chartData[goalId]) {
        throw "Invalid data";
      }
  
      let data = chartData[goalId]?.chartData;
      if(!data) {
        throw "Goal chart data not found";
      }
  
      return data;
    } catch(err) {
      console.error("Error in treatment summary chart preview", err);
      return {};
    }
  }, [goalId, chartData]);

  return (
    <div className="py-2">
      <div
        className="cardCstm rounded-3 p-3"
        style={{ background: "#FBFBE6" }}
      >
        <div className="top d-flex align-items-start">
          <h5 className="m-0 fw-bold themeBlue">{index + 1}.</h5>
          <div className="px-3">
            <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
              Area
            </h5>
            <p className="m-0 themeBlue pt-1">
              {goal?.assesmentGoalDisciplineArea?.name}
            </p>
          </div>
          <div className="px-3">
            <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
              Goal
            </h5>
            <p className="m-0 themeBlue pt-1">{goal?.assesmentGoalDetail?.title}</p>
          </div>
        </div>
        <div className="bottom pt-4">
          <Row>
            <Col lg="8">
              <LineGraph
                dates={dates}
                series={series}
                ref={innerRef}
              />
            </Col>
            <Col lg="4">
              <div
                className="p-3 rounded-3 graphColorLevel"
                style={{ background: "#EBEBD0" }}
              >
                <ul
                  className="list-unstyled ps-0 mb-0 position-relative list"
                  style={{ zIndex: 9 }}
                >
                  {series?.length && series.map((param, index) => {
                    let paramColor = GOAL_TRACK_PARAMETERS_COLORS[param.name];
                    return (
                      <li key={index} className="py-2 d-flex align-items-center justify-content-between gap-10">
                        <div className="left d-flex align-items-center gap-10">
                          <div className="d-flex align-items-center gap-10">
                            <input
                              type="checkbox"
                              style={{ height: 20, width: 20, opacity: 0 }}
                              className="form-check"
                              // onChange={() => {
                              //   handleToggleTrackParam(param.name)
                              // }}
                              checked={true}
                              disabled
                            />
                          </div>
                          <div className="d-flex align-items-center gap-10">
                            <p
                              className="d-flex m-0 bg-white align-items-center justify-content-center rounded-pill fw-bold"
                              style={{
                                border: `2px solid ${paramColor}`,
                                color: paramColor,
                                height: 30,
                                width: 30,
                              }}
                            >
                              {param.name}
                            </p>
                            <p className="m-0">{param.name}</p>
                          </div>
                        </div>
                        <div className="right">
                          <div
                            className="rounded"
                            style={{
                              background: paramColor,
                              height: 4,
                              width: 20,
                            }}
                          ></div>
                        </div>
                      </li> 
                    )
                  })}
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
})

export default TreatmentSummaryGoalsPreview;